var _classCallCheck = require("/Users/qw/WebstormProjects/jwc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/qw/WebstormProjects/jwc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var error =
/*#__PURE__*/
function () {
  "use strict";

  function error(code, msg) {
    _classCallCheck(this, error);

    var _error = new Error();

    _error.code = code;
    _error.message = msg ? "Bmob.Error:{code:".concat(code, ", message:").concat(msg, "}") : "Bmob.Error:{code:".concat(code, ", message:").concat(this.errorMsg(code), "}");
    return _error;
  }

  _createClass(error, [{
    key: "errorMsg",
    value: function errorMsg(code) {
      switch (code) {
        case 415:
          // 参数类型不正确
          return 'incorrect parameter type.';

        case 416:
          // 参数为空
          return 'Parameter is null.';

        case 417:
          // 内容为空
          return 'There is no upload content.';

        case 418:
          // 内容为空
          return 'Log in failure.';

        case 419:
          // 内容为空
          return 'Bmob.GeoPoint location error.';

        default:
          return 'unknown error';
      }
    }
  }]);

  return error;
}();

module.exports = error;